/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
/* eslint-disable arrow-body-style */
import jsPsychAudioMultiResponse from "@jspsych-contrib/plugin-audio-multi-response";
import store from "store2";
// import {itemId} from "../config/corpus"
import { jsPsych } from "../jsPsych";
import {
  shuffle,
  updateProgressBar,
  addItemToSortedStoreList,
  getPrompt,
} from "../helperFunctions";
// eslint-disable-next-line import/no-cycle
import { multichoiceValidityEvaluator } from "../experiment";
import { mediaAssets } from "../experimentSetup";
import { isPractice } from "./subTask";
import { audioResponse } from "./audioFeedback";
import { isMaxTimeoutReached } from "./appTimer";

export const audioContext = new Audio();

const prepareSurveyChoices = (target, distractors) => {
  // randomly select a location for the correct answer
  const randIndex = Math.floor(Math.random() * (distractors.length + 1));

  // randomize the order of the distractors
  const stimulus = shuffle(distractors);
  let choices = [];
  for (let i = 0; i < distractors.length; i++) {
    choices.push(stimulus[i]);
  }

  // insert the target
  choices.splice(randIndex, 0, target);

  return {
    target: target,
    choices: choices,
    correctResponseNum: randIndex,
  };
};

const trialsMapped = [0, 1].map((i) => {
  const isPracticeTrial = i === 0;
  const assessmentStage = isPracticeTrial
    ? "practice_response"
    : "test_response";
  return {
    type: jsPsychAudioMultiResponse,
    response_allowed_while_playing: true,
    data: () => ({
      // Modify to use a function to dynamically set data
      save_trial: true,
      assessment_stage: assessmentStage,
    }),
    stimulus: mediaAssets.audio.nullAudio,
    prompt: () => getPrompt(),
    prompt_above_buttons: true,
    button_choices: () => {
      const stimulus = store.session.get("nextStimulus");
      const { target } = stimulus;
      const d1 = stimulus.distractor1;
      const d2 = stimulus.distractor2;
      const d3 = stimulus.distractor3;

      const trialInfo = prepareSurveyChoices(target, [d1, d2, d3]);

      store.session.set("target", target);
      store.session.set("correctResponseNum", trialInfo.correctResponseNum);
      store.session.set("choices", trialInfo.choices);

      return trialInfo.choices;
    },
    button_html: () => {
      return "<button>%choice%</button>";
    },
    on_load: () => {
      const btnOption = store.session.get("config").buttonLayout;
      document
        .getElementById("jspsych-audio-multi-response-btngroup")
        .classList.add(`${btnOption}-layout`);

      if (store.session.get("config").task === "cva") {
        document.getElementById("decorated").style.textDecoration = "underline";
        document.getElementById("decorated").style.textDecorationThickness =
          "2px";
      }

      store.session.transact("trialNumSubtask", (oldVal) => oldVal + 1);
      const subTaskName = store.session("subTaskName");
      if (!isPractice(subTaskName)) {
        store.session.transact("trialNumTotal", (oldVal) => oldVal + 1);
      }
    },
    on_finish: (data) => {
      const nextStimulus = store.session("nextStimulus");
      const choices = store.session("choices");
      const subTaskName = store.session("subTaskName");
      let totalPercentCorrect;

      // eslint-disable-next-line no-param-reassign
      data.correct =
        data.button_response === store.session("correctResponseNum") ? 1 : 0;
      store.session.set("correct", data.correct);
      store.session.set("response", data.button_response);
      store.session.set("responseValue", choices[data.button_response]);

      if (data.correct === 1) {
        if (!isPractice(subTaskName)) {
          store.session.set("previousItem", store.session.get("nextStimulus"));
          store.session.set("previousAnswer", data.correct);
          store.session.transact("totalCorrect", (oldVal) => oldVal + 1);
        }
      } else {
        store.session.set("previousItem", store.session.get("nextStimulus"));
        store.session.set("previousAnswer", 0);
        addItemToSortedStoreList("incorrectItems", store.session("target"));
      }

      totalPercentCorrect = Math.round(
        (100 * store.session.get("totalCorrect")) /
          store.session.get("trialNumTotal"),
      );
      store.session.set("totalPercentCorrect", totalPercentCorrect);

      // Update engagement flags

      multichoiceValidityEvaluator.addResponseData(
        data.rt,
        data.button_response,
        data.correct,
      );

      let itemId;
      if (
        (nextStimulus.itemId === undefined || nextStimulus.itemId === null) &&
        assessmentStage === "practice_response"
      ) {
        itemId = "practiceItem";
      } else {
        itemId = nextStimulus.itemId;
      }

      jsPsych.data.addDataToLastTrial({
        item: nextStimulus.item,
        itemId: itemId,
        assessment_stage: assessmentStage,
        target: store.session("target"),
        choices: store.session("choices"),
        decorated: nextStimulus.decorated,
        distractor1: nextStimulus.distractor1,
        distractor2: nextStimulus.distractor2,
        distractor3: nextStimulus.distractor3,
        corpusId: isPractice(subTaskName)
          ? store.session.get("config").practiceCorpus
          : store.session.get("config").stimulusCorpus,
        response: store.session("responseValue"),
        responseNum: data.button_response,
        correctResponseNum: store.session("correctResponseNum"),
        correct: data.correct,
        replay: store.session("ifReplay"),
      });
      store.session.set("ifReplay", 0);

      if (!isPractice(subTaskName)) {
        updateProgressBar();
      }
      // log trial results for debugging
      // let temp = jsPsych.data.getLastTrialData();
      // console.log(temp.trials[0]);
    },
  };
});

export const [practiceTrials, stimulusTrials] = trialsMapped;

// A single practice or stimulus trial, which will be skipped if AppTimer has expired
// eslint-disable-next-line consistent-return
export const trialWrapped = (trialType = "") => {
  if (trialType === "practice") {
    return {
      timeline: [practiceTrials],
      // eslint-disable-next-line consistent-return
      conditional_function: () => {
        // don't play when skipping trials because app is finished
        if (isMaxTimeoutReached()) return false;
      },
    };
  }
  if (trialType === "stimulus") {
    return {
      timeline: [stimulusTrials],
      // eslint-disable-next-line consistent-return
      conditional_function: () => {
        // don't play when skipping trials because app is finished
        if (isMaxTimeoutReached()) return false;
      },
    };
  }
};

export const ifRealTrialResponse = {
  timeline: [audioResponse],

  conditional_function: () => {
    // don't play when skipping trials because app is finished
    if (isMaxTimeoutReached()) return false;

    // doesn't apply to practice trials
    const subTaskName = store.session("subTaskName");
    if (isPractice(subTaskName)) {
      return false;
    }
    return true;
  },
};
